/**
 * lib-core
 *
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ItemRegistry } from "@adapptio/lib-shared";
import { TGenericDataSourceDefinition } from "@adapptio/lib-blueprint";

/**
 * DataSource Definition Registry
 */
export type IDataSourceDefRegistry = ItemRegistry<TGenericDataSourceDefinition>;

export class DataSourceDefRegistry extends ItemRegistry<TGenericDataSourceDefinition> {}
